import script from "./index.vue?vue&type=script&setup=true&name=Header&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=Header&lang=js"

import "./index.vue?vue&type=style&index=0&id=b56f7814&lang=scss"

const __exports__ = script;

export default __exports__